<template>
    <div class="row form-group">
        <div class="col-sm-3 col-form-label">Расписание блюда</div>
        <div class="col-sm-9 col-form-label">
            <template v-if="schedules.length">
                <ul class="list-unstyled mb-1">
                    <li
                        v-for="(schedule, index) in schedules"
                        :key="schedule.id || index"
                        class="mb-1">
                        {{ getScheduleDays(schedule.week_days) }}:
                        <strong>{{ formatTime(schedule.from) }} – {{ formatTime(schedule.to) }}</strong>
                        <span v-if="schedule.from > schedule.to" class="text-muted"> (до следующего дня)</span>
                        <span v-else-if="schedule.from === schedule.to" class="text-muted"> (пустой интервал)</span>
                    </li>
                </ul>
                <small class="form-text text-muted">
                    Время московское (МСК). Вне этих интервалов блюдо скрыто в приложении.
                </small>
                <small class="form-text text-muted">
                    Следующий импорт iiko заменит расписание данными из iiko.
                </small>
            </template>
            <span v-else>Без ограничений по расписанию блюда.</span>
        </div>
    </div>
</template>

<script>
    const WEEK_DAYS = [
        ['monday', 'Пн'],
        ['tuesday', 'Вт'],
        ['wednesday', 'Ср'],
        ['thursday', 'Чт'],
        ['friday', 'Пт'],
        ['saturday', 'Сб'],
        ['sunday', 'Вс']
    ];

    export default {
        name: 'DishSchedule',
        props: {
            schedules: {
                type: Array,
                default: () => []
            }
        },
        methods: {
            getScheduleDays(weekDays) {
                const days = WEEK_DAYS.filter(([day]) => (weekDays || []).includes(day));
                if (days.length === 7) return 'Ежедневно';
                return days.length ? days.map(([, label]) => label).join(', ') : 'Дни не выбраны — блюдо недоступно';
            },
            formatTime(time) {
                return typeof time === 'string' && time.length === 8 && time.endsWith(':00')
                    ? time.slice(0, 5)
                    : time;
            }
        }
    };
</script>
